<template>
<div>
  <common-title :title="'批量创建'"></common-title>
  <div class="buzhou-div">
    <el-steps :active="step" :space="200" align-center :process-status="'wait'">
      <el-step title="上传信息" description=""></el-step>
      <el-step title="确认信息" description=""></el-step>
      <el-step :title="$t('common.fineshed')" description=""></el-step>
    </el-steps>
  </div>

  <div v-if="step==1">
    <div><span>附件下载:</span></div>
    <el-button @click="downLoadExcel" icon="el-icon-download" type="primary" size="mini">下载模板</el-button>
    <div><span>请参考此文件格式填写信息。支持Excel格式，文件大小上限为100MB。</span></div>

    <div style="margin-top: 20px;"><span>附件上传:</span></div>
    <div style="width:20%;">
      <el-upload
          class="upload-demo"
          :action="uploadUrl"
          :limit="1"
          :on-success="uploadSuccess"
          :file-list="fileList"
          :on-exceed="moreTip"
          :on-remove="handleRemove"
          :before-upload="beforeUpload">
        <el-button icon="el-icon-document" size="mini" type="primary">选择文件</el-button>
        <div slot="tip" class="el-upload__tip">支持<i>xlsx</i>格式，文件大小上限为<i>100MB</i>。</div>
      </el-upload>
    </div>
    <div style="margin-top: 20px;">
      <!-- <create-user-tip-component></create-user-tip-component> -->
      <el-button @click="nextFunc01" icon="el-icon-check" size="mini" type="primary">{{$t("common.Next")}}</el-button>
    </div>
  </div>
  <div v-if="step==2">
    <table class="dataTabble">
      <thead>
        <tr>
          <th width="">导入结果</th>
          <th width="">Excel序号</th>
          <th width="">账号<span class="redspan">*</span></th>
          <th width="">密码<span class="redspan">*</span></th>
          <th width="">角色<span class="redspan">*</span></th>
          <th width="">姓名<span class="redspan">*</span></th>
          <th width="">机构<span class="redspan">*</span></th>
          <th width="">联系邮箱<span class="redspan">*</span></th>
          <th width="">联系手机号</th>
          <th width="">操作</th>
        </tr>
      </thead>
      <tbody v-model="tableData">
        <tr v-for="(item,index) in tableData" :key="index">
          <td>
            <div v-if="item.errorType.length==0">
              <i class="el-icon-circle-check greenicon"></i>
            </div>
            <div v-if="item.errorType.length!=0" class="error-info-box">
              <div>
                <i class="el-icon-circle-close redicon"></i>
              </div>
<!--              // 1：信息不全-->
<!--              // 2：账号重复-->
<!--              // 3：机构错误-->
<!--              // 4：密码格式错误-->
<!--              // 5：邮箱格式错误-->
<!--              // 6：手机号格式错误-->
              <div>
                <p v-if="item.errorType.indexOf(1)>=0">信息不全</p>
                <p v-if="item.errorType.indexOf(2)>=0">账号重复</p>
                <p v-if="item.errorType.indexOf(3)>=0">机构错误</p>
                <p v-if="item.errorType.indexOf(4)>=0">密码格式错误</p>
                <p v-if="item.errorType.indexOf(5)>=0">邮箱格式错误</p>
<!--                <p v-if="item.errorType.indexOf(6)>=0">手机号格式错误</p>-->
              </div>
            </div>
          </td>
          <td>{{item.excelNum}}</td>
          <td :class="isLoginNameOkFunc(item)?'':'red'">{{item.loginName}}</td>
          <td :class="item.password && item.errorType.indexOf(4)<=0?'':'red'">{{item.password}}</td>
          <td :class="item.roleName?'':'red'">{{item.roleName}}</td>
          <td :class="item.name?'':'red'">{{item.name}}</td>
          <td :class="(isOrganOkFunc(item) && item.organ)?'':'red'">{{item.organ}}</td>
          <td :class="item.email && item.errorType.indexOf(5)<0?'':'red'">{{item.email}}</td>
          <td>{{item.phone}}</td>
          <td>
            <div class="tabopa">
              <el-button
                size="mini"
                icon="el-icon-edit"
                @click="handleEdit(index,item)">编辑</el-button>
              <el-button
                size="mini"
                icon="el-icon-delete"
                type="danger"
                @click="handleDelete(index,item)">删除</el-button>
            </div>
          </td>
        </tr>
      </tbody>
    </table>
    <div style="margin-top: 20px;">
      <el-button @click="toBefore(1)" icon="el-icon-check" size="mini" type="primary">上一步</el-button>
      <el-button @click="nextFunc02" icon="el-icon-check" size="mini" type="primary">{{$t("common.Next")}}</el-button>
    </div>
  </div>

  <!--       完成     -->
  <div class="sucess-out" v-if="step==3">

    <div class="sucess-img-out">
        <div class="sucess-img"></div>
        <span>批量创建成功！</span>
        <span>系统将向联系邮箱和手机号发送“邀请TA绑定账号”的信息！</span>
        <el-button icon="el-icon-check" size="mini" type="primary" @click="toPageList">确认</el-button>
    </div>

    <div class="sucess-img-out" v-if="false">
<!--      <div class="sucess-img"></div>-->
      <i class="el-icon-error fail-img"></i>
      <span>批量创建失败！</span>
      <span>请核对并修改信息后，再重新提交。</span>
      <el-button icon="el-icon-check" size="mini" type="primary">确认</el-button>
    </div>
  </div>

  <search-edit-user-component ref="search-edit-user" @changeUserInfoItemByIndex="changeUserInfoItemByIndex"></search-edit-user-component>
  <h-popup ref="delete-user" @confirm="confirmDelete">
    <template slot="title">{{ $t("common.tip") }}</template>
    <template slot="tip"> {{ $t("common.isConfirmdelete") }} </template>
  </h-popup>

</div>
</template>

<script>
import hPopup from "@/components/common/hPopup";
import createUserTipComponent from "@/components/user/createUserTipComponent";
import searchEditUserComponent from "@/components/paper/searchEditUserComponent";
import commonTitle from "@/components/common/commonTitle";
import config from "../../api/config";
export default {
//   errorType:[1,2,3]
//   数组里面存的是数字，然后
// 1：信息不全
// 2：账号重复
// 3：机构错误
// 4：密码格式错误
// 5：邮箱格式错误
// 6：手机号格式错误
  data(){
    return {
      step:1,
      uploadUrl: config.baseURL+ "/conference/user/excelUpload",
      // uploadUrl: 'http://47.104.20.126:20201/financial-search/api'+ "/file/upload",
      fileList:[],
      fileName:'',
      tableData: null,
      currentId:'',
    }
  },
  components:{
    createUserTipComponent,
    searchEditUserComponent,
    hPopup,
    commonTitle,
  },
  methods:{
    toPageList(){
      this.$router.push({
        name:'userList'
      })
    },
    isLoginNameOkFunc(item){
      let res = true;
      if(item.errorType.indexOf(2)>=0){
        res = false
      }
      if(item.loginName == ''){
        res = false
      }
      return res;
    },
    isOrganOkFunc(item){
      let res = true;
      if(item.errorType.indexOf(3)>=0){
        res = false
      }
      if(item.organ == ''){
        res = false
      }
      return res;
    },
    //前端编辑
    handleEdit(index,item){
      this.$refs['search-edit-user'].hadleOpen(index,item);
    },
    downLoadExcel() {
      // let url = config.baseURL + '/conference/user/downloadTemplate';
      let url = 'https://financial-search.oss-cn-beijing.aliyuncs.com/meeting/%E6%89%B9%E9%87%8F%E5%88%9B%E5%BB%BA%E7%94%A8%E6%88%B7%E6%A8%A1%E6%9D%BF.xlsx';
      var form = document.createElement("form");
      document.body.appendChild(form);
      form.method = "get";
      form.action = url
      form.submit();
    },
    nextFunc01(){
      if(!this.tableData){
        this.$message.error(this.$t("msg.pleaseUpload"));
      }else{
        this.step= 2;
      }
    },
    toBefore(num){
      this.step= num;
      this.tableData = null;
    },
    nextFunc02(){
      //校验是否成功
      let isSuccess = true;
      this.tableData.some(item=>{
        if(item.errorType.length>0){
          isSuccess = false;
          return true;
        }
      })
      if(isSuccess){

        // 调用批量插入接口
        this.setExcelData();
      }else{
        this.$message.error("校验未通过");
      }
    },
    /**
     * 删除
     * */
    handleDelete(index, row) {
      this.currentId = index;
      this.$refs["delete-user"].openDialog();
    },
    confirmDelete(){
      this.$refs["delete-user"].closeDialog();
      this.$message.success("删除成功");
      this.tableData.splice(this.currentId,1);
    },
    /**
     * 文件上传相关
     * */
    // 1：信息不全
// 2：账号重复
// 3：机构错误
// 4：密码格式错误
// 5：邮箱格式错误
// 6：手机号格式错误
    uploadSuccess(res,file) {
      if(res.code == 200){
        res.data.forEach(item=>{
          if(!this.testEmail(item.email)){
            item.errorType.push(5)
          }
          // if(!this.testPhone(item.phone)){
          //   item.errorType.push(6)
          // }
          if(!this.testPass(item.password)){
            item.errorType.push(4)
          }
        })
        this.tableData = res.data;
      }
    },
    // 文件超出一个
    moreTip(){
      this.$message.error(this.$t("msg.onlyfile"))
    },
    // beforeRemove(file){
    //     return this.$confirm(`确定移除 ${ file.name }？`);
    // },
    handleRemove(){
      // this.ruleForm.url = '',
      this.fileName  = ''
      this.tableData = null;
    },
    // 上传图片前文件校验
    beforeUpload(file) {
      // console.log('file==>',file)
      // const isPdf = file.type === "application/xlsx";
      const isPdf = file.name.toLowerCase().includes("xlsx");
      const isLt100M = file.size / 1024 / 1024 < 100;

      if (!isPdf) {
        this.$message.error("上传文件只能是xlsx格式!");
      }
      if (!isLt100M) {
        this.$message.error("上传文件大小不能超过 100MB!");
      }
      return isPdf && isLt100M;
    },
    /**
     * 请求相关
     * */
    requestExcelData(){
      // let data = {}
      // this.$api.requestExcelData(data).then((res)=>{
      //
      // })
      // this.tableData = [{
      //   loginName:'zs',
      //   password:'a123455',
      //   roleCode:'1',
      //   roleName:'管理员',
      //   name:'张三1',
      //   organ:'机构SD',
      //   email:'sdf@13.com',
      //   phone:'158565665656',
      //   excelNum:1,
      //   errorType:[],
      //   msg:''
      // },{
      //   loginName:'zsss',
      //   password:'a123455',
      //   roleCode:'1',
      //   roleName:'管理员',
      //   name:'张三1',
      //   organ:'机构SD',
      //   email:'',
      //   phone:'158565665656',
      //   excelNum:2,
      //   errorType:[1,2,3],
      //   msg:''
      // },{
      //   loginName:'zsss',
      //   password:'a123455',
      //   roleCode:'',
      //   roleName:'',
      //   name:'张三1',
      //   organ:'机构SD',
      //   email:'',
      //   phone:'158565665656',
      //   excelNum:3,
      //   errorType:[1,2],
      //   msg:''
      // }]
    },
    changeUserInfoItemByIndex(item,index){
      //请求后端校验账号是否重复

      //请求后端校验账号是否重复 end
      this.tableData[index].name = item.name;
      this.tableData[index].loginName = item.loginName;
      this.tableData[index].password = item.password;
      this.tableData[index].roleCode = item.roleCode;
      this.tableData[index].roleName = this.getRoleNameByCode(item.roleCode);//这里需要从字典获取
      this.tableData[index].name = item.name;
      this.tableData[index].organ = item.organ;
      this.tableData[index].email = item.email;
      this.tableData[index].phone = item.phone;
      this.tableData[index].errorType = [];
    },
    getRoleNameByCode(code){
      let name = '';
      this.$store.state.dict.RoleList.some(x=>{
        if(x.roleCode == code){
          name = x.roleName;
          return true;
        }
      })
      return name;
    },
    setExcelData(){
      this.tableData.forEach(x=>{
        x.meetingCode = this.$store.state.dict.currentMeetingCode
      })
      let data = this.tableData

      this.$api.saveUserInfoRegister(data).then(res=>{
        if(res.code == 200){
          this.step= 3;
        }
      })
    },
    testEmail(value){
      const reg = /^[a-zA-Z0-9_.-]+@[a-zA-Z0-9-]+(\.[a-zA-Z0-9-]+)*\.[a-zA-Z0-9]{2,6}$/;
      return reg.test(value);
    },
    testPhone(value){
      let reg =  /^1[3456789]\d{9}$/;
      return reg.test(value);
    },
    testPass(value){
      const reg = /^[A-Za-z0-9]{6,18}$/
      return reg.test(value);
    },
  }
}
</script>

<style scoped lang="scss">
  .me-button{
    border-radius: 2px;
    background:#3774FE ;
    color:#fff;
    height: 48px;
    text-align: center;
    line-height: 48px;
    font-size: 16px;
    cursor: pointer;
    margin-top: 50px;
  }

  .error-info-box{
    display: flex;
    justify-content: center;
    align-items: center;
  }

  .dataTabble{
    width:100%;
    .redspan{
      color:red;
    }
    .greenicon{
      color: #fff;
      background: green;
      border-radius: 20px;
      font-size: 14px;
    }
    .redicon{
      color: #fff;
      background: red;
      border-radius: 20px;
      font-size: 14px;
    }
    thead{
      width:100%;
      tr{
        height:60px;
        font-size: 14px;
        border-bottom: 1px solid #e4e9ef;
        color: #979797;
      }
      th{
        padding:0 10px;
        text-align: center;
      }
    }
    tbody{
      tr{
        height:60px;
        font-size: 16px;
        border-bottom: 1px solid #e4e9ef;
        transition: background-color .2s;
        text-align: center;
      }
      tr:hover{
        background: #f5f7fa;
      }
      td{
        padding:0 10px;
        font-size: 14px;
      }
      .red{
        border: 1px solid red;
        background: rgba(255,0,0,0.2);
      }
    }
  }

  .sucess-out{
    width:800px;
    .sucess-img-out{
      display: flex;
      justify-content: center;
      align-items: center;
      flex-direction: column;
      .sucess-img{
        margin-top: 20px;
        width:100px;
        height: 100px;
        background-size: 100% 100%;
        background: url(../../assets/login/icon-sucess-mini.png) no-repeat center;
      }
      .fail-img{
         margin-top: 20px;
         width:100px;
         height: 100px;
         background-size: 100% 100%;
         font-size: 100px;
         color: red;
         //background: url(../../assets/login/icon-sucess-mini.png) no-repeat center;
       }
      span{
        margin: 0 0 0 10px;
      }
    }
  }
</style>
